import { ACTION_EVENT_LEADS_LOADED, ACTION_EVENT_SINGLE_LEAD_UPDATED } from '../../../actions/leads';

const DEFAULT_STATE = {
    list: [],
};

export default function leadScanReducer(state, action) {
    if (!state) {
        state = { ...DEFAULT_STATE };
    }

    switch (action.type) {
        case ACTION_EVENT_LEADS_LOADED:
            state = {
                ...state,
                list: action.leads,
            };
            break;
        case ACTION_EVENT_SINGLE_LEAD_UPDATED:
            state = {
                ...state,
                list: state.list.filter((lead) => lead.scan_uuid != action.lead.scan_uuid).concat(action.lead),
            };
            break;
    }

    return state;
}
